import { isNonEmptyArray } from "web/services/helpers"
import { Icon } from "web/components"

export default function Errors({ errors }) {
  return isNonEmptyArray(errors) ? (
    <div className="mt-5 rounded-md bg-red-50 p-4">
      <div className="flex">
        <div className="shrink-0">
          <Icon name="x-circle" className="h-5 w-5 text-red-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            There
            {errors.length > 1
              ? ` were ${errors.length} problems`
              : " was 1 problem"}{" "}
            with this import
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <ul className="list-disc space-y-1 pl-5">
              {errors.map((e, index) => (
                <li key={index}>{e}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  ) : null
}
